<template>
    <div class="">
      <v-dialog
      class="upgrade-strategy popbox"
        name="dialog2"
        v-model="isShow"
        :title="dialogTitle"
        close-on-click-modal
        :modal="true"
        :width="668"
        @open="open"
        @after-close="handleAfterClose"
        @confirm="handleConfirm"
        append-to-body
      >
        <v-form ref="form" :model="ruleForm" :rules="rules">
          <v-form-item label="升级策略类型" prop="strategy_type">
            <v-select id="set_strategy_type" insertContains="set_strategy_type" name="strategy_type" v-model="ruleForm.strategy_type" :options="upgradeTypeOptions"></v-select>
          </v-form-item>
        <!-- 基于ID，必须有原版本和目标版本 -->
        <v-form-item label="源版本" prop="source_ver_id"  v-if="this.ruleForm.strategy_type != 'base-sn'">
          <v-select id="set_source_version1"  is-search insertContains="set_source_version1" v-model="ruleForm.source_ver_id" name="source_ver_id" :options="resver"></v-select>
        </v-form-item>
        <!-- <v-form-item label="源版本" prop="source_ver_id" :required="false"  v-if="this.ruleForm.strategy_type == 'base-sn'">
          <v-select id="set_source_version2" insertContains="set_source_version2" v-model="ruleForm.source_ver_id" name="source_ver_id" :options="resver"></v-select>
        </v-form-item>
         -->
        <v-form-item label="目标版本" prop="target_ver_id" >
          <v-select id="set_target_version" :placeholder="resver.length > 0 ? '请选择' : '请先新建版本'" is-search insertContains="set_target_version" v-model="ruleForm.target_ver_id" name="target_ver_id" :options="resver"></v-select>
        </v-form-item>


          <v-form-item class="listfile" label="策略文件" prop="listFile"  :required="false">
            <v-upload
            action="/cgi-bin/upload"
            ref="upload"
            name="upload"
            :WfileName="WfileName"
            accept=".txt,.bin"
            show-file-list
            :on-change="hidemsg"
            :noName="noName"
            @showtips="showfiletips"
            ></v-upload>
            <span class="tips1"  v-if="ruleForm.strategy_type === 'base-sn'">文件内容格式为:
              <span class="tipsspan">SN1
                <div class="setsn1">SN2</div>
                <div class="setsn2">...</div>
              </span>
            </span>
            <span class="toptip" v-if="ruleForm.strategy_type === 'base-sn'">
                <v-col :offset="1" :span="2">
                    <v-tooltip
                      :max-width="210"
                      content="添加此策略使上传文件内的SN号与指定版本绑定，使拥有这些SN号的设备们在升级时可以升级到此指定版本"
                      trigger="click"
                      position="top-center"
                    >
                      <span><img src="../../assets/img/tips.png" alt=""></span>
                    </v-tooltip>
                </v-col>
            </span>
            <span class="tips1 tipdif" v-if="ruleForm.strategy_type === 'base-mac'">文件内容格式为:
              <span class="tipsspan">SN1,MAC1
                <div class="setsn1">SN2,MAC2</div>
                <div class="setsn2">...</div>
              </span>
            </span>
            <span class="toptip" v-if="ruleForm.strategy_type === 'base-mac'">
                <v-col :offset="1" :span="2">
                    <v-tooltip
                      :max-width="210"
                      content="添加此策略使上传文件内的MAC和SN与当前版本和指定版本绑定，使拥有这些MAC和SN且当前软件版本号与策略的当前版本号相同的设备们在升级时可以升级到此指定版本"
                      trigger="click"
                      position="top-center"
                    >
                      <span><img src="../../assets/img/tips.png" alt=""></span>
                    </v-tooltip>
                </v-col>
            </span>
            <div class="filetip" ref="filetip">未选择文件</div>
          </v-form-item>
          <!-- <div class="filetips"><span>sdasd</span></div> -->
          <v-form-item label="备注" prop="memo" :required="false">
            <v-input type="textarea" class="remarks" name="memo" :maxlength="200" v-model="ruleForm.memo" show-word-limit></v-input>
          </v-form-item>

        </v-form>
        <v-loading class="loading-box"  :visible="!upTips" name="loading4"></v-loading>
      </v-dialog>
    </div>
</template>

  <script>
import OSS from 'ali-oss'
import SparkMD5 from 'spark-md5'

  export default {
    components: {},
    props:{
      showInputDialog:{
        type:Boolean,
        default: false
      }
    },
    data() {
      return {
        resver:[],
        rules: {
          memo: "",  //备注
        },
        ruleForm:{
          strategy_type: 'base-sn',      // 升级类型
          dev_type:'',
          source_ver_id: "",    //源版本
          target_ver_id: "",    //目标版本
          memo: "",  //备注
          file_url: "",
          file_hash: "",
          app_id: sessionStorage.getItem("appid") || "",
        },
        address:'',
        showDialog: false,

        isShow:false,
        WfileName:'',
        dialogTitle: "规则配置",
        upgradeTypeOptions: [
          {
            label: "基于设备KEY",
            value: 'base-sn'
          },
          {
            label: "基于设备KEY和MAC",
            value: 'base-mac'
          }
        ],
        upTips:true,
        noName:false,
        productKeyOptins:[]
      };
    },
    created() {
    },
    watch:{
      showInputDialog(newVal){
        this.isShow = newVal
      }
    },
    methods: {
      showfiletips(){
        this.$refs.filetip.style.display = "block";
      },
      open(){
        this.getProductList()
        setTimeout(() => {
          this.getData()
        }, 1000)
        this.getversion()
      },
      hidemsg(e,file){
        if(file.indexOf('.bin')==-1 && file.indexOf('.txt')==-1){
          this.$message.error("只支持bin、txt格式的文件")
          this.noName = true
          return false
        }
        this.noName = false
        this.$refs.filetip.style.display = "none";
        this.$message.warn("文件上传中,请等待...")
        this.upTips = false
      let _this = this
      if (window.FileReader) {
        var fi = e.target.files[0];
        const fileReader = new FileReader()
        fileReader.readAsBinaryString(fi);
        fileReader.onload = e => {
          const md5 = SparkMD5.hashBinary(e.target.result);
          _this.ruleForm.file_hash = md5.toUpperCase()
        }
       }
      this.address = this.ruleForm.strategy_type == 'base-sn' ? `/${sessionStorage.getItem("appid") || ""}/common-strategy/base-sn/` : `/${sessionStorage.getItem('appid') || ''}/common-strategy/base-mac/`
      this.client.put(`${this.address}` + file, e.target.files[0]).then((result) => {
        if(result.res.statusCode == 200){
          this.WfileName = file
          this.$message.success("文件上传成功")
          this.upTips = true
          this.ruleForm.file_url = result.url
        }else{
          this.$message.error("文件上传失败")
          this.upTips = true
        }
      })
    },
    getProductList(){
        const submitData = {
          app_id: sessionStorage.getItem("appid") || "",
        }
        this.$post("/td/td-iot-api/iot/common/product/list/v1", submitData, false).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.productKeyOptins = res.data.map((item) =>{
              return {
                label: item.product_name,
                value: item.product_key
              }
            })
          }else {
            this.$message.error(res.msg);
          }
        });
    },
    async getData(){
      const res = await this.$getData(
        "/td/td-iot-api/iot/oss-bridge/sts-token/v1",
      );
      this.client = new OSS({
        region: 'oss-cn-shenzhen',
        secure:true,
        accessKeyId: res.data.access_key_id,
        accessKeySecret: res.data.access_key_secret,
        bucket: 'tenda-iot' ,
        stsToken:res.data.security_token
      });
    },
    async getversion(){
        const submitData = {
          app_id: sessionStorage.getItem("appid") || "",
        }
        const res = await this.$getData(
          "/td/td-iot-api/iot/firmware/version-list/v1",submitData
        );
        this.resver = res.data.list
        this.resver.forEach((x)=>{
          this.productKeyOptins.map((item)=>{
            if(x.product_key == item.value){
              x.productName = item.label
            }
          })
          x.label = x.productName + "_"+  x.version  + "_" + x.type
          x.value = x.id
        })
      },
      handleConfirm() {
        const valid = this.$refs.form.submitForm();
        if (valid === false) {
          return;
        }
         // 如果是sn和mac模式 则必须上传固件
      if(this.ruleForm.strategy_type == 'base-sn' || this.ruleForm.strategy_type == 'base-mac'){
       if(this.ruleForm.file_url == ''){
        this.$refs.filetip.style.display = "block";
        this.$message.error("请检查错误信息")
        return
        }
      }
        this.ruleForm.dev_type = this.ruleForm.strategy_type == 'base-sn' ? 'router' : 'mesh'
        this.ruleForm.source_ver_id = Number(this.ruleForm.source_ver_id)
        this.ruleForm.target_ver_id = Number(this.ruleForm.target_ver_id)
        let submitData = { ...this.ruleForm };
        this.$post("/td/td-iot-api/iot/white-list/v1", submitData, false).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.$emit('getData')
            this.$message.success(res.msg);
          }
          else {
            this.$message.error(res.msg);
          }
        });
        this.$emit('update:showInputDialog',false)
        Object.assign(this.$data, this.$options.data())
      },
      handleAfterClose() {
        this.$emit('update:showInputDialog',false)
        Object.assign(this.$data, this.$options.data())
        this.$emit('getData')
      },
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">

.upgrade-strategy{
    .v-form-item .v-form-item__content{
      display: inline-block;
        margin-left: 24px!important;
        max-width: 320px;
    }
    .listfile .tips1{
      display: inline-block;
      vertical-align: middle;
      margin-left: 8px;
      height: 32px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #999999;
      line-height: 14px;
      .tipsspan{
        position: relative;
      }
    }
    .v-col__2{
      width: 100%;
    }
}

  </style>
